var n = Object.defineProperty;
var h = (a, e, t) => e in a ? n(a, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[e] = t;
var i = (a, e, t) => h(a, typeof e != "symbol" ? e + "" : e, t);
import { Storages as s } from "./chunk331.js";
import { decrypt as l } from "./chunk356.js";
import { isDefined as u } from "./chunk324.js";
import { encrypt as g } from "./chunk355.js";
class f {
  constructor(e, t) {
    i(this, "_storage", null);
    i(this, "_secretKey", null);
    i(this, "_storageName", s.Local);
    this.storage = e, this._secretKey = t ?? null;
  }
  set storage(e) {
    switch (this._storageName = e, e) {
      case s.Local:
      case s.Secret:
        this._storage = window.localStorage;
        break;
      case s.Session:
        this._storage = window.sessionStorage;
        break;
      case s.Cookie:
        this._storage = null;
        break;
      default:
        this._storage = null;
        break;
    }
  }
  set setSecretKey(e) {
    this._secretKey = e;
  }
  get webStorage() {
    return this._storage;
  }
  get(e) {
    if (this._storageName === s.Secret && !this._secretKey)
      throw new Error("Secret key not provided!");
    const t = this.webStorage ? this.webStorage.getItem(e) : document.cookie.match(`(^|;) ?${e}=([^;]*)(;|$)`);
    if (!t) return null;
    try {
      let r = this.webStorage ? t : t[2];
      try {
        this._secretKey && this._storageName === s.Secret && (r = l(r, this._secretKey));
      } catch {
        return null;
      }
      return r ? JSON.parse(r) : null;
    } catch {
      return this.webStorage ? t ?? null : t ? t[2] : null;
    }
  }
  set(e, t, r) {
    if (u(t)) {
      if (this._storageName === s.Secret && !this._secretKey)
        throw new Error("Secret key not provided!");
      try {
        let o = JSON.stringify(t);
        if (this._secretKey && this._storageName === s.Secret && (o = g(o, this._secretKey)), this.webStorage) {
          this.webStorage.setItem(e, o);
          return;
        }
        const c = [`${e}=${o}`];
        r && c.push(`; ${r}`), document.cookie = c.join("");
        return;
      } catch (o) {
        console.error(o);
      }
    }
  }
  clear(e, t) {
    try {
      if (this.webStorage) {
        this.webStorage.removeItem(e);
        return;
      }
      const r = [`${e}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`];
      t && r.push(`; ${t}`), document.cookie = r.join("");
      return;
    } catch (r) {
      console.error(r);
    }
  }
  clearAll() {
    var e;
    try {
      if (this.webStorage) {
        this.webStorage.clear();
        return;
      }
      (((e = document.cookie) == null ? void 0 : e.split(";")) ?? []).forEach((r) => {
        const o = r.indexOf("="), c = o > -1 ? r.substr(0, o) : r;
        document.cookie = c + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      });
      return;
    } catch (t) {
      console.error(t);
    }
  }
}
export {
  f as StorageHelper
};
